import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "41",
  height: "41",
  fill: "none",
  viewBox: "0 0 41 41"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "36",
      height: "36",
      x: "2.519",
      y: "2.032",
      fill: "#EE8208",
      rx: "6"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M18.27 24.898a10.3 10.3 0 0 1-3.198-1.325 1.617 1.617 0 0 1-.541-2.214 1.607 1.607 0 0 1 2.228-.556c.767.465 1.58.801 2.463.961q2.608.47 4.893-.87c.311-.183.626-.326.996-.324a1.63 1.63 0 0 1 1.556 1.148 1.61 1.61 0 0 1-.661 1.827 10.1 10.1 0 0 1-3.078 1.312l-.159.042c.045.048.08.087.116.123q1.463 1.461 2.922 2.924c.57.57.69 1.353.311 2.006-.543.94-1.793 1.096-2.578.318-.97-.966-1.936-1.937-2.905-2.904l-.143-.156c-.033.058-.05.113-.085.148q-1.454 1.46-2.914 2.914c-.668.667-1.688.662-2.333-.001a1.617 1.617 0 0 1-.036-2.21c.076-.088.16-.17.242-.252l2.79-2.791.116-.12zm2.25-15.603a5.55 5.55 0 0 1 5.54 5.54 5.534 5.534 0 0 1-5.536 5.541 5.53 5.53 0 0 1-5.126-7.654 5.55 5.55 0 0 1 5.122-3.427m2.291 5.545a2.29 2.29 0 0 0-2.276-2.296c-1.273-.002-2.31 1.019-2.312 2.275-.003 1.26 1.02 2.308 2.25 2.309 1.308.001 2.337-1.007 2.338-2.288",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }